import React, { PropTypes, Component } from 'react';

export default class LoginForm extends Component {
  static cid = '登录';
  static propTypes = {
    style: PropTypes.object,
    cid: PropTypes.string,
    username: PropTypes.string,
    usernamePlaceholder: PropTypes.string,
    password: PropTypes.string,
    passwordPlaceholder: PropTypes.string,
    loginText: PropTypes.string,
    err: PropTypes.string,
    succMsg: PropTypes.string,
    setFormData: PropTypes.func,
    onLogin: PropTypes.func,
    onFindPwd: PropTypes.func,
    onRegister: PropTypes.func,
    needVerify: PropTypes.bool,
  };
  componentWillMount() {
    window.LXPage(window.serveData.lxData.mobileLogin.id);
  }
  onSubmit = (evt) => {
    evt.preventDefault();
    this.props.onLogin();
  };
  changeVal = (name, value) => {
    this.props.setFormData(name, value);
  };
  onFindPwd = (evt) => {
    evt.preventDefault();
    this.props.onFindPwd();
  };
  onRegister = (evt) => {
    evt.preventDefault();
    this.props.onRegister();
  }
  render() {
    return (
      <form className="login-form"
        onSubmit={this.onSubmit}
        style={this.props.style}
      >
        {this.props.err ?
          <p className="login-tip err-tip" >
            <i>&times;</i>
            {this.props.err || '用户名或密码输入有误，请重新输入！'}
          </p> : <p></p>
        }
        <label className="login-input">
          <i className="prefix pms-font-guest-2" />
          <input
            type="text"
            placeholder={this.props.usernamePlaceholder || '手机号'}
            autoFocus={true}
            value={this.props.username}
            onChange={e => this.changeVal('username', e.target.value.trim())}
          />
          {this.props.username !== '' && <i className="suffix" onClick={() => this.changeVal('username', '')}>&times;</i>}
        </label>
        <label className="login-input">
          <i className="prefix pms-font-lock" />
          <input
            type="password"
            placeholder={this.props.passwordPlaceholder || '密码'}
            value={this.props.password}
            onChange={e => this.changeVal('password', e.target.value.trim())}
          />
          {this.props.password !== '' && <i className="suffix" onClick={() => this.changeVal('password', '')}>&times;</i>}
        </label>
        <button
          type="submit"
          className="btn btn-primary login-btn"
          data-cid={this.props.cid}
          data-act="登录"
          style={{ position: this.props.needVerify ? 'relative' : '', marginTop: this.props.needVerify ? '180px' : '' }}
        >{this.props.loginText || '登录'}</button>
        {typeof this.props.onRegister === 'function' && <a
          href="/pms/register"
          className="btn btn-link login-register"
          data-cid={this.props.cid}
          data-act="新用户注册"
        >新用户注册</a>}
        {typeof this.props.onFindPwd === 'function' && <a
          href=""
          className="btn btn-link forget-passwd"
          onClick={this.onFindPwd}
          data-cid={this.props.cid}
          data-act="找回密码"
        >忘记密码</a>}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/user/login-form.js